import React from 'react'

export const PinterestIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <g clipPath="url(#clip0_1_2787)">
                <path d="M10 0C4.478 0 0 4.477 0 10C0 14.237 2.636 17.855 6.356 19.312C6.268 18.521 6.189 17.307 6.391 16.444C6.573 15.664 7.563 11.474 7.563 11.474C7.563 11.474 7.264 10.874 7.264 9.988C7.264 8.598 8.07 7.56 9.074 7.56C9.926 7.56 10.338 8.2 10.338 8.968C10.338 9.826 9.793 11.108 9.51 12.298C9.274 13.293 10.01 14.105 10.99 14.105C12.768 14.105 14.134 12.231 14.134 9.525C14.134 7.132 12.414 5.457 9.957 5.457C7.112 5.457 5.442 7.592 5.442 9.797C5.442 10.656 5.773 11.578 6.187 12.078C6.22243 12.1159 6.24742 12.1624 6.25951 12.2129C6.27161 12.2634 6.2704 12.3161 6.256 12.366L5.978 13.499C5.934 13.682 5.833 13.722 5.643 13.633C4.394 13.052 3.613 11.226 3.613 9.759C3.613 6.605 5.905 3.707 10.221 3.707C13.69 3.707 16.386 6.18 16.386 9.483C16.386 12.93 14.213 15.703 11.196 15.703C10.183 15.703 9.231 15.178 8.905 14.555L8.282 16.933C8.056 17.802 7.447 18.891 7.038 19.554C7.975 19.844 8.969 20 10 20C15.522 20 20 15.523 20 10C20 4.477 15.522 0 10 0Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_1_2787">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
